import angular from 'angular';
import { searchTermsAndTunerComponent } from './searchTermsAndTunerComponent';

angular.module('sh.searchTermsAndTuner', []).component('shSearchTermsAndTuner', searchTermsAndTunerComponent());
